/* eslint-disable @typescript-eslint/member-ordering */
import { Inject, Injectable } from '@angular/core';

import { Environment } from '@personalized-supplements/environments/env';
import { CookieService } from 'ngx-cookie-service';
import { map, of } from 'rxjs';

import { ENVIRONMENT } from '../providers/environment.provider';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private _cookieService: CookieService,
    @Inject(ENVIRONMENT) private _env: Environment,
  ) {}

  public get token(): string {
    return this._cookieService.get(this.cookieName);
  }
  public set token(v: string) {
    this._cookieService.set(this.cookieName, v, undefined, '/', this._env.cookieDomain);
  }

  public get cookieName(): string {
    return this._env.cookieName ?? '';
  }

  hasTokens() {
    return !!this._cookieService.get(this.cookieName);
  }

  hasTokens$() {
    return of(null).pipe(map(() => this.hasTokens()));
  }

  remove() {
    this._cookieService.deleteAll();
    this._cookieService.deleteAll('/', this._env.cookieDomain);
  }
}
